export default "__VITE_ASSET__C$pq8Lot__"